import { medalLandscape } from "./medal-landscape.js";
/** Celebration snapshots and community posts resolve the same bundled medal. */
export function routeAwardMedal(award) {
    const kind = award.kind === "completion" ? "completion" : "waypoint";
    return {
        kind,
        ordinal: kind === "completion" ? 0 : award.milestoneOrdinal,
        landscape: medalLandscape(award.routeName, kind === "completion" ? null : award.milestoneTitle),
    };
}
export function routeAwardFeedLine(award, firstName) {
    const who = award.subject === "group" ? `${firstName} and ${award.groupName ?? "their group"}` : firstName;
    return award.kind === "completion"
        ? `${who} earned the ${award.routeName} finisher award.`
        : `${who} earned the ${award.milestoneTitle} award on ${award.routeName}.`;
}
//# sourceMappingURL=route-award-presentation.js.map